"use strict";
exports.__esModule = true;
exports.toLink = exports.toMediaLink = exports.toWebLink = exports.toDocumentLink = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var constants_1 = require("../constants");
var lang_1 = require("./lang");
var text_1 = require("./text");
var toDocumentLink = function (prismicLink, logger) {
    var id = prismicLink === null || prismicLink === void 0 ? void 0 : prismicLink.id;
    if (!id) {
        return undefined;
    }
    return utils_1.compact({
        linkType: types_1.LinkType.Document,
        id: id,
        type: constants_1.toDocumentType(prismicLink.type, logger),
        lang: lang_1.toLang(prismicLink.lang, logger),
        uid: prismicLink.uid
    });
};
exports.toDocumentLink = toDocumentLink;
var toWebLink = function (prismicLink, logger) {
    var url = logger.required(text_1.toText(prismicLink === null || prismicLink === void 0 ? void 0 : prismicLink.url));
    if (!url) {
        return undefined;
    }
    return {
        linkType: types_1.LinkType.Web,
        url: url
    };
};
exports.toWebLink = toWebLink;
var toMediaLink = function (prismicLink, logger) {
    var url = logger.required(text_1.toText(prismicLink === null || prismicLink === void 0 ? void 0 : prismicLink.url));
    if (!url) {
        return undefined;
    }
    return utils_1.compact({
        linkType: types_1.LinkType.Media,
        url: url,
        name: text_1.toText(prismicLink.name),
        size: prismicLink.size
    });
};
exports.toMediaLink = toMediaLink;
var LINK_TYPE_TO_MAPPER = {
    Web: exports.toWebLink,
    Document: exports.toDocumentLink,
    Media: exports.toMediaLink
};
var toLink = function (prismicLink, logger) {
    var linkType = prismicLink === null || prismicLink === void 0 ? void 0 : prismicLink.link_type;
    var fn = logger.toConstValue(linkType, LINK_TYPE_TO_MAPPER);
    return fn ? fn(prismicLink, logger) : undefined;
};
exports.toLink = toLink;
//# sourceMappingURL=link.js.map